var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrow = function SvgArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    viewBox: "0 0 59.56 56.06",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58,30.73a3.81,3.81,0,0,0,0-5.3L34.1,1.52a3.77,3.77,0,0,0-5.33,0h0a3.83,3.83,0,0,0,0,5.33L50,28.08,28.77,49.34a3.77,3.77,0,0,0,5.33,5.3ZM.87,31.85H55.33V24.31H.87Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow.7e85d818.svg";
export { ForwardRef as ReactComponent };